/* カート内モーダル */
$(".cart-slider-02 span").on("click", function () {
    $(this).toggleClass("active");
    $(".splide-processing-02").toggleClass("active");
    $(".modal-bg-black-02").toggleClass("active");
    $("body").toggleClass("fixed");
});

$(".modal-bg-black-02").on("click", function () {
    $(this).toggleClass("active");
    $(".splide-processing-02").toggleClass("active");
    $(".cart-slider-02 span").toggleClass("active");
    $("body").toggleClass("fixed");
});

$(".splide-processing-02 .close-btn__wrap img").on("click", function () {
    $(".modal-bg-black-02").toggleClass("active");
    $(".splide-processing-02").toggleClass("active");
    $(".cart-slider-02 span").toggleClass("active");
    $("body").toggleClass("fixed");
});

$(".splide-processing-btn-02 .complete").on("click", function () {
    $(".modal-bg-black-02").toggleClass("active");
    $(".splide-processing-02").toggleClass("active");
    $(".cart-slider-02 span").toggleClass("active");
    $("body").toggleClass("fixed");
});

/* スライダー矢印の制御 */
function backbtn02() {
    $(".splide-processing-02 .splide__arrow--prev").click();
}

function nextbtn02() {
    $(".splide-processing-02 .splide__arrow--next").click();
}

/* カート内の選択によってあとのスライドの内容を変更する */
/* 社名と個人名の切り替え*/
$(document).ready(function () {
    $('input[name="attributes[【加工2】加工内容(詳細)]"]').on("change", function () {
        if ($(".splide-processing-02 .company-radio").is(":checked")) {
            $(".splide-processing-02 .personal-content").hide();
            $(".splide-processing-02 .company-content").show();
        } else if ($(".splide-processing-02 .personal-radio").is(":checked")) {
            $(".splide-processing-02 .company-content").hide();
            $(".splide-processing-02 .personal-content").show();
        } else {
            $(".splide-processing-02 .personal-content").hide();
            $(".splide-processing-02 .company-content").hide();
        }
    });
});
/* 日本語と英字の切り替え */
$(document).ready(function () {
    $('input[name="attributes[【加工2】デザイン(フォント)の指定]"]').on("change", function () {
        if ($(".splide-processing-02 .jp-font").is(":checked")) {
            $(".splide-processing-02 .en-content").hide();
            $(".splide-processing-02 .jp-content").show();
        } else if ($(".splide-processing-02 .en-font").is(":checked")) {
            $(".splide-processing-02 .jp-content").hide();
            $(".splide-processing-02 .en-content").show();
        } else {
            $(".splide-processing-02 .jp-content").hide();
            $(".splide-processing-02 .en-content").hide();
        }
    });
});

/* お問合せ専用項目を選択したとき */
$(document).ready(function () {
    $("input[type='radio']").on("change", function () {
        if ($(this).hasClass("p2-radio-contact") && $(this).is(":checked")) {
            $(".splide-processing-02 .cart-contact__wrap.caution__wrap").css("display", "block");
            $(".splide-processing-btn-02 .next").addClass("active_contact");
            $(".splide-processing-btn-02 .back").addClass("active_contact");
        } else {
            $(".splide-processing-02 .cart-contact__wrap.caution__wrap").css("display", "none");
            $(".splide-processing-btn-02 .next").removeClass("active_contact");
            $(".splide-processing-btn-02 .back").removeClass("active_contact");
        }
    });
});

/* 1スライド目 入力チェック */
$(document).ready(function () {
    $('input[name="attributes[【加工2】加工内容(大枠)]"]').change(function () {
        if ($('input[name="attributes[【加工2】加工内容(大枠)]"]:checked').length > 0) {
            $(".splide-processing-02 .next.check01").removeClass("disabled");
        } else {
            $(".splide-processing-02 .next.check01").addClass("disabled");
        }
    });
});

/* 2スライド目 入力チェック */
$(document).ready(function () {
    $('input[name="attributes[【加工2】加工内容(詳細)]"]').change(function () {
        if ($('input[name="attributes[【加工2】加工内容(詳細)]"]:checked').length > 0) {
            $(".splide-processing-02 .next.check02").removeClass("disabled");
        } else {
            $(".splide-processing-02 .next.check02").addClass("disabled");
        }
    });
});

/* 3スライド目 入力チェック */
/* 社名側 */
$(document).ready(function () {
    $('input[name="【加工2】社名について注意事項の同意"]').change(function () {
        if ($('input[name="【加工2】社名について注意事項の同意"]:checked').length > 0) {
            $(".splide-processing-02 .next.check03").removeClass("disabled");
        } else {
            $(".splide-processing-02 .next.check03").addClass("disabled");
        }
    });
});
/* 個人名側 */
$(document).ready(function () {
    $('input[name="【加工2】個人名について注意事項の同意"]').change(function () {
        if ($('input[name="【加工2】個人名について注意事項の同意"]:checked').length > 0) {
            $(".splide-processing-02 .next.check03").removeClass("disabled");
        } else {
            $(".splide-processing-02 .next.check03").addClass("disabled");
        }
    });
});

/* 4スライド目 入力チェック */
$(document).ready(function () {
    $('input[name="attributes[【加工2】デザイン(フォント)の指定]"]').change(function () {
        if ($('input[name="attributes[【加工2】デザイン(フォント)の指定]"]:checked').length > 0) {
            $(".splide-processing-02 .next.check04").removeClass("disabled");
        } else {
            $(".splide-processing-02 .next.check04").addClass("disabled");
        }
    });
});

/* 5スライド目 入力チェック */
/* 社名側かつ日本語フォントの場合 */
// アルファベット入力&11文字以上入力時のアラート

// 共通バリデーションチェック関数
function p2_companyJpTargetInputCmn() {
    const inputField = document.getElementById("p2-step05-company-check-jp");
    const nonAlphabetErrorMessage = document.getElementById("p2-step05-company-error-jp");
    const lengthErrorMessage = document.getElementById("p2-length-error-message-jp");
    const textErrorMessage = document.getElementById("p2-empty-error-message-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsInvalidCharacters = /[a-zA-Z]/.test(inputField.value);

    // 「.product-option dd」のいずれかに「〜5文字」が存在するかどうかのチェック
    const productOptions = document.querySelectorAll(".product-option dd");
    let lengthLimit = 10; // デフォルトの文字数上限
    let isCustomOption = false;

    productOptions.forEach((option) => {
        if (option.textContent.trim() === "〜5文字") {
            lengthLimit = 5; // 条件に一致した場合、文字数上限を5に変更
            isCustomOption = true;
        }
    });

    const exceedsLength = inputField.value.length > lengthLimit;
    const isEmpty = inputField.value.length === 0;

    // 5文字上限の場合、エラーメッセージを変更する
    if (isCustomOption) {
        lengthErrorMessage.innerHTML =
            "現在のオプションでは6文字以上入力できません。<br>加工オプション内の文字数オプションを変更してください。";
    }

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    return !containsInvalidCharacters && !exceedsLength && !isEmpty;

    /*
    if (!containsInvalidCharacters && !exceedsLength && !isEmpty) {
        nextButton.classList.remove("disabled");
    }
    */
}
// 社名（かな） 1商品目バリデーションチェック関数
function p2_companyJpTargetInput01() {
    const inputField = document.getElementById("p2-company-jp-target-01");
    const textErrorMessage = document.getElementById("p2-company-product-empty-01-jp");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyJpTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（かな） 2商品目バリデーションチェック関数
function p2_companyJpTargetInput02() {
    const inputField = document.getElementById("p2-company-jp-target-02");
    const textErrorMessage = document.getElementById("p2-company-product-empty-02-jp");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyJpTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（かな） 3商品目バリデーションチェック関数
function p2_companyJpTargetInput03() {
    const inputField = document.getElementById("p2-company-jp-target-03");
    const textErrorMessage = document.getElementById("p2-company-product-empty-03-jp");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyJpTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（かな） 4商品目バリデーションチェック関数
function p2_companyJpTargetInput04() {
    const inputField = document.getElementById("p2-company-jp-target-04");
    const textErrorMessage = document.getElementById("p2-company-product-empty-04-jp");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyJpTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（かな） 5商品目バリデーションチェック関数
function p2_companyJpTargetInput05() {
    const inputField = document.getElementById("p2-company-jp-target-05");
    const textErrorMessage = document.getElementById("p2-company-product-empty-05-jp");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyJpTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（かな） 6商品目バリデーションチェック関数
function p2_companyJpTargetInput06() {
    const inputField = document.getElementById("p2-company-jp-target-06");
    const textErrorMessage = document.getElementById("p2-company-product-empty-06-jp");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyJpTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（かな） 7商品目バリデーションチェック関数
function p2_companyJpTargetInput07() {
    const inputField = document.getElementById("p2-company-jp-target-07");
    const textErrorMessage = document.getElementById("p2-company-product-empty-07-jp");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyJpTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（かな） 8商品目バリデーションチェック関数
function p2_companyJpTargetInput08() {
    const inputField = document.getElementById("p2-company-jp-target-08");
    const textErrorMessage = document.getElementById("p2-company-product-empty-08-jp");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyJpTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（かな） 9商品目バリデーションチェック関数
function p2_companyJpTargetInput09() {
    const inputField = document.getElementById("p2-company-jp-target-09");
    const textErrorMessage = document.getElementById("p2-company-product-empty-09-jp");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyJpTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（かな） 10商品目バリデーションチェック関数
function p2_companyJpTargetInput10() {
    const inputField = document.getElementById("p2-company-jp-target-10");
    const textErrorMessage = document.getElementById("p2-company-product-empty-10-jp");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyJpTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名入力・変更時のバリデーションチェック
document.getElementById("p2-step05-company-check-jp").addEventListener("input", function (e) {
    // バリデーションチェックを実行
    p2_companyJpTargetInputCmn();
});

// 【1商品目】選択時のバリデーションチェック
$("#p2-company-jp-item-01 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-jp-target-01").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-01-jp").css("display", "table-cell");
    $(".p2-step05-company-01-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-company-01-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyJpTargetInputCmn();
    p2_companyJpTargetInput01();
});

// 【2商品目】選択時のバリデーションチェック
$("#p2-company-jp-item-02 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-jp-target-02").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-02-jp").css("display", "table-cell");
    $(".p2-step05-company-02-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-company-02-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyJpTargetInputCmn();
    p2_companyJpTargetInput02();
});

// 【3商品目】選択時のバリデーションチェック
$("#p2-company-jp-item-03 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-jp-target-03").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-03-jp").css("display", "table-cell");
    $(".p2-step05-company-03-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-company-03-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyJpTargetInputCmn();
    p2_companyJpTargetInput03();
});

// 【4商品目】選択時のバリデーションチェック
$("#p2-company-jp-item-04 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-jp-target-04").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-04-jp").css("display", "table-cell");
    $(".p2-step05-company-04-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-company-04-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyJpTargetInputCmn();
    p2_companyJpTargetInput04();
});

// 【5商品目】選択時のバリデーションチェック
$("#p2-company-jp-item-05 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-jp-target-05").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-05-jp").css("display", "table-cell");
    $(".p2-step05-company-05-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-company-05-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyJpTargetInputCmn();
    p2_companyJpTargetInput05();
});

// 【6商品目】選択時のバリデーションチェック
$("#p2-company-jp-item-06 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-jp-target-06").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-06-jp").css("display", "table-cell");
    $(".p2-step05-company-06-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-company-06-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyJpTargetInputCmn();
    p2_companyJpTargetInput06();
});

// 【7商品目】選択時のバリデーションチェック
$("#p2-company-jp-item-07 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-jp-target-07").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-07-jp").css("display", "table-cell");
    $(".p2-step05-company-07-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-company-07-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyJpTargetInputCmn();
    p2_companyJpTargetInput07();
});

// 【8商品目】選択時のバリデーションチェック
$("#p2-company-jp-item-08 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-jp-target-08").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-08-jp").css("display", "table-cell");
    $(".p2-step05-company-08-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-company-08-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyJpTargetInputCmn();
    p2_companyJpTargetInput08();
});

// 【9商品目】選択時のバリデーションチェック
$("#p2-company-jp-item-09 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-jp-target-09").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-09-jp").css("display", "table-cell");
    $(".p2-step05-company-09-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-company-09-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyJpTargetInputCmn();
    p2_companyJpTargetInput09();
});

// 【10商品目】選択時のバリデーションチェック
$("#p2-company-jp-item-10 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-jp-target-10").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-10-jp").css("display", "table-cell");
    $(".p2-step05-company-10-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-company-10-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyJpTargetInputCmn();
    p2_companyJpTargetInput10();
});

/* 社名 商品入力欄の追加（日本語） 20241018 */
$(document).ready(function () {
    let currentIndex = 1;
    const maxIndex = 10; // 表示する要素の最大数

    $(".splide-processing-02 .add-company-btn-jp__wrap").on("click", function () {
        if (currentIndex < maxIndex) {
            currentIndex++;
            let nextElement = $(
                ".splide-processing-02 .individual__wrap.company-con.btn01.jp.num" +
                    currentIndex.toString().padStart(2, "0")
            );

            if (nextElement.length) {
                nextElement.show();
            }

            const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
            nextButton.classList.add("disabled");

            // currentIndexが最大数に達したらボタンを非表示にする
            if (currentIndex === maxIndex) {
                $(".splide-processing-02 .add-company-btn-jp__wrap").hide();
            }
        }
    });
});

/* 社名側かつ英字フォントの場合 */
// 日本語入力&11文字以上入力時のアラート

// 共通バリデーションチェック関数
function p2_companyEnTargetInputCmn() {
    const inputField = document.getElementById("p2-step05-company-check-en");
    const nonAlphabetErrorMessage = document.getElementById("p2-step05-company-error-en");
    const lengthErrorMessage = document.getElementById("p2-length-error-message-en");
    const textErrorMessage = document.getElementById("p2-empty-error-message-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);

    // 「.product-option dd」のいずれかに「〜10文字」が存在するかどうかのチェック
    const productOptions = document.querySelectorAll(".product-option dd");
    let lengthLimit = 15; // デフォルトの文字数上限
    let isCustomOption = false;

    productOptions.forEach((option) => {
        if (option.textContent.trim() === "〜10文字") {
            lengthLimit = 10; // 条件に一致した場合、文字数上限を5に変更
            isCustomOption = true;
        }
    });

    const exceedsLength = inputField.value.length > lengthLimit;
    const isEmpty = inputField.value.length === 0;

    // 10文字上限の場合、エラーメッセージを変更する
    if (isCustomOption) {
        lengthErrorMessage.innerHTML =
            "現在のオプションでは10文字以上入力できません。<br>加工オプション内の文字数オプションを変更してください。";
    }

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    return !containsInvalidCharacters && !exceedsLength && !isEmpty;

    /*
    if (!containsInvalidCharacters && !exceedsLength && !isEmpty) {
        nextButton.classList.remove("disabled");
    }
    */
}
// 社名（英） 1商品目バリデーションチェック関数
function p2_companyEnTargetInput01() {
    const inputField = document.getElementById("p2-company-en-target-01");
    const textErrorMessage = document.getElementById("p2-company-product-empty-01-en");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyEnTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（英） 2商品目バリデーションチェック関数
function p2_companyEnTargetInput02() {
    const inputField = document.getElementById("p2-company-en-target-02");
    const textErrorMessage = document.getElementById("p2-company-product-empty-02-en");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyEnTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（英） 3商品目バリデーションチェック関数
function p2_companyEnTargetInput03() {
    const inputField = document.getElementById("p2-company-en-target-03");
    const textErrorMessage = document.getElementById("p2-company-product-empty-03-en");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyEnTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（英） 4商品目バリデーションチェック関数
function p2_companyEnTargetInput04() {
    const inputField = document.getElementById("p2-company-en-target-04");
    const textErrorMessage = document.getElementById("p2-company-product-empty-04-en");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyEnTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（英） 5商品目バリデーションチェック関数
function p2_companyEnTargetInput05() {
    const inputField = document.getElementById("p2-company-en-target-05");
    const textErrorMessage = document.getElementById("p2-company-product-empty-05-en");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyEnTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（英） 6商品目バリデーションチェック関数
function p2_companyEnTargetInput06() {
    const inputField = document.getElementById("p2-company-en-target-06");
    const textErrorMessage = document.getElementById("p2-company-product-empty-06-en");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyEnTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（英） 7商品目バリデーションチェック関数
function p2_companyEnTargetInput07() {
    const inputField = document.getElementById("p2-company-en-target-07");
    const textErrorMessage = document.getElementById("p2-company-product-empty-07-en");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyEnTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（英） 8商品目バリデーションチェック関数
function p2_companyEnTargetInput08() {
    const inputField = document.getElementById("p2-company-en-target-08");
    const textErrorMessage = document.getElementById("p2-company-product-empty-08-en");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyEnTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（英） 9商品目バリデーションチェック関数
function p2_companyEnTargetInput09() {
    const inputField = document.getElementById("p2-company-en-target-09");
    const textErrorMessage = document.getElementById("p2-company-product-empty-09-en");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyEnTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名（英） 10商品目バリデーションチェック関数
function p2_companyEnTargetInput10() {
    const inputField = document.getElementById("p2-company-en-target-10");
    const textErrorMessage = document.getElementById("p2-company-product-empty-10-en");
    const isEmpty = inputField.value.length === 0;
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");

    if (isEmpty) {
        inputField.classList.add("error_04");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        textErrorMessage.style.display = "none";
    }

    if (!isEmpty && p2_companyEnTargetInputCmn()) {
        nextButton.classList.remove("disabled");
    }
}

// 社名入力・変更時のバリデーションチェック
document.getElementById("p2-step05-company-check-en").addEventListener("input", function (e) {
    // バリデーションチェックを実行
    p2_companyEnTargetInputCmn();
});

// 【1商品目】選択時のバリデーションチェック
$("#p2-company-en-item-01 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-en-target-01").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-01-en").css("display", "table-cell");
    $(".p2-step05-company-01-en").prev("th").css("display", "table-cell");
    $(".p2-step05-company-01-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyEnTargetInputCmn();
    p2_companyEnTargetInput01();
});

// 【2商品目】選択時のバリデーションチェック
$("#p2-company-en-item-02 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-en-target-02").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-02-en").css("display", "table-cell");
    $(".p2-step05-company-02-en").prev("th").css("display", "table-cell");
    $(".p2-step05-company-02-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyEnTargetInputCmn();
    p2_companyEnTargetInput02();
});

// 【3商品目】選択時のバリデーションチェック
$("#p2-company-en-item-03 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-en-target-03").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-03-en").css("display", "table-cell");
    $(".p2-step05-company-03-en").prev("th").css("display", "table-cell");
    $(".p2-step05-company-03-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyEnTargetInputCmn();
    p2_companyEnTargetInput03();
});

// 【4商品目】選択時のバリデーションチェック
$("#p2-company-en-item-04 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-en-target-04").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-04-en").css("display", "table-cell");
    $(".p2-step05-company-04-en").prev("th").css("display", "table-cell");
    $(".p2-step05-company-04-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyEnTargetInputCmn();
    p2_companyEnTargetInput04();
});

// 【5商品目】選択時のバリデーションチェック
$("#p2-company-en-item-05 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-en-target-05").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-05-en").css("display", "table-cell");
    $(".p2-step05-company-05-en").prev("th").css("display", "table-cell");
    $(".p2-step05-company-05-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyEnTargetInputCmn();
    p2_companyEnTargetInput05();
});

// 【6商品目】選択時のバリデーションチェック
$("#p2-company-en-item-06 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-en-target-06").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-06-en").css("display", "table-cell");
    $(".p2-step05-company-06-en").prev("th").css("display", "table-cell");
    $(".p2-step05-company-06-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyEnTargetInputCmn();
    p2_companyEnTargetInput06();
});

// 【7商品目】選択時のバリデーションチェック
$("#p2-company-en-item-07 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-en-target-07").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-07-en").css("display", "table-cell");
    $(".p2-step05-company-07-en").prev("th").css("display", "table-cell");
    $(".p2-step05-company-07-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyEnTargetInputCmn();
    p2_companyEnTargetInput07();
});

// 【8商品目】選択時のバリデーションチェック
$("#p2-company-en-item-08 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-en-target-08").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-08-en").css("display", "table-cell");
    $(".p2-step05-company-08-en").prev("th").css("display", "table-cell");
    $(".p2-step05-company-08-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyEnTargetInputCmn();
    p2_companyEnTargetInput08();
});

// 【9商品目】選択時のバリデーションチェック
$("#p2-company-en-item-09 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-en-target-09").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-09-en").css("display", "table-cell");
    $(".p2-step05-company-09-en").prev("th").css("display", "table-cell");
    $(".p2-step05-company-09-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyEnTargetInputCmn();
    p2_companyEnTargetInput09();
});

// 【10商品目】選択時のバリデーションチェック
$("#p2-company-en-item-10 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-company-en-target-10").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-company-10-en").css("display", "table-cell");
    $(".p2-step05-company-10-en").prev("th").css("display", "table-cell");
    $(".p2-step05-company-10-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_companyEnTargetInputCmn();
    p2_companyEnTargetInput10();
});

/* 社名 商品入力欄の追加（英語） 20241018 */
$(document).ready(function () {
    let currentIndex = 1;
    const maxIndex = 10; // 表示する要素の最大数

    $(".splide-processing-02 .add-company-btn-en__wrap").on("click", function () {
        if (currentIndex < maxIndex) {
            currentIndex++;
            let nextElement = $(
                ".splide-processing-02 .individual__wrap.company-con.btn01.en.num" +
                    currentIndex.toString().padStart(2, "0")
            );

            if (nextElement.length) {
                nextElement.show();
            }

            const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
            nextButton.classList.add("disabled");

            // currentIndexが最大数に達したらボタンを非表示にする
            if (currentIndex === maxIndex) {
                $(".splide-processing-02 .add-company-btn-en__wrap").hide();
            }
        }
    });
});

/* 個人名側かつ日本語フォントの場合 */
/* 個人名（日本語フォント）のバリデーションチェック */
// アルファベット入力&4文字以上入力時のアラート

/* -------------------- */
/* ------ 1商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-01-jp").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-01-jp");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-01-jp");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-01-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-jp-target-input01");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 4;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-01-jp").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-01-jp");
    const targetInput = document.getElementById("p2-jp-target-input01");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 商品情報のバリデーションチェック */
function p2_validateJpTargetInput01() {
    const inputField = document.getElementById("p2-jp-target-input01");
    const textErrorMessage = document.getElementById("p2-product-empty-01-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-jp-item-01 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-jp-target-input01").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-01-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateJpTargetInput01();
});

/* -------------------- */
/* ------ 2商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-02-jp").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-02-jp");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-02-jp");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-02-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-jp-target-input02");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 4;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-02-jp").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-02-jp");
    const targetInput = document.getElementById("p2-jp-target-input02");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 商品情報のバリデーションチェック */
function p2_validateJpTargetInput02() {
    const inputField = document.getElementById("p2-jp-target-input02");
    const textErrorMessage = document.getElementById("p2-product-empty-02-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-jp-item-02 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-jp-target-input02").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-02-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateJpTargetInput02();
});

/* -------------------- */
/* ------ 3商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-03-jp").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-03-jp");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-03-jp");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-03-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-jp-target-input03");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 4;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-03-jp").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-03-jp");
    const targetInput = document.getElementById("p2-jp-target-input03");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 商品情報のバリデーションチェック */
function p2_validateJpTargetInput03() {
    const inputField = document.getElementById("p2-jp-target-input03");
    const textErrorMessage = document.getElementById("p2-product-empty-03-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-jp-item-03 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-jp-target-input03").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-03-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateJpTargetInput03();
});

/* -------------------- */
/* ------ 4商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-04-jp").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-04-jp");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-04-jp");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-04-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-jp-target-input04");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 4;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-04-jp").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-04-jp");
    const targetInput = document.getElementById("p2-jp-target-input04");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 商品情報のバリデーションチェック */
function p2_validateJpTargetInput04() {
    const inputField = document.getElementById("p2-jp-target-input04");
    const textErrorMessage = document.getElementById("p2-product-empty-04-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-jp-item-04 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-jp-target-input04").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-04-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateJpTargetInput04();
});

/* -------------------- */
/* ------ 5商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-05-jp").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-05-jp");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-05-jp");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-05-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-jp-target-input05");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 4;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-05-jp").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-05-jp");
    const targetInput = document.getElementById("p2-jp-target-input05");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 商品情報のバリデーションチェック */
function p2_validateJpTargetInput05() {
    const inputField = document.getElementById("p2-jp-target-input05");
    const textErrorMessage = document.getElementById("p2-product-empty-05-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-jp-item-05 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-jp-target-input05").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-05-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateJpTargetInput05();
});

/* -------------------- */
/* ------ 6商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-06-jp").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-06-jp");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-06-jp");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-06-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-jp-target-input06");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 4;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-06-jp").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-06-jp");
    const targetInput = document.getElementById("p2-jp-target-input06");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 商品情報のバリデーションチェック */
function p2_validateJpTargetInput06() {
    const inputField = document.getElementById("p2-jp-target-input06");
    const textErrorMessage = document.getElementById("p2-product-empty-06-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-jp-item-06 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-jp-target-input06").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-06-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateJpTargetInput06();
});

/* -------------------- */
/* ------ 7商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-07-jp").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-07-jp");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-07-jp");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-07-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-jp-target-input07");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 4;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-07-jp").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-07-jp");
    const targetInput = document.getElementById("p2-jp-target-input07");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 商品情報のバリデーションチェック */
function p2_validateJpTargetInput07() {
    const inputField = document.getElementById("p2-jp-target-input07");
    const textErrorMessage = document.getElementById("p2-product-empty-07-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-jp-item-07 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-jp-target-input07").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-07-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateJpTargetInput07();
});

/* -------------------- */
/* ------ 8商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-08-jp").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-08-jp");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-08-jp");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-08-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-jp-target-input08");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 4;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-08-jp").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-08-jp");
    const targetInput = document.getElementById("p2-jp-target-input08");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 商品情報のバリデーションチェック */
function p2_validateJpTargetInput08() {
    const inputField = document.getElementById("p2-jp-target-input08");
    const textErrorMessage = document.getElementById("p2-product-empty-08-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-jp-item-08 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-jp-target-input08").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-08-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateJpTargetInput08();
});

/* -------------------- */
/* ------ 9商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-09-jp").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-09-jp");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-09-jp");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-09-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-jp-target-input09");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 4;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-09-jp").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-09-jp");
    const targetInput = document.getElementById("p2-jp-target-input09");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 商品情報のバリデーションチェック */
function p2_validateJpTargetInput09() {
    const inputField = document.getElementById("p2-jp-target-input09");
    const textErrorMessage = document.getElementById("p2-product-empty-09-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-jp-item-09 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-jp-target-input09").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-09-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateJpTargetInput09();
});

/* -------------------- */
/* ------ 10商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-10-jp").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-10-jp");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-10-jp");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-10-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-jp-target-input10");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 4;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-10-jp").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-10-jp");
    const targetInput = document.getElementById("p2-jp-target-input10");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsAlphabet = /[a-zA-Z]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsAlphabet) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsAlphabet && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 日本語 商品情報のバリデーションチェック */
function p2_validateJpTargetInput10() {
    const inputField = document.getElementById("p2-jp-target-input10");
    const textErrorMessage = document.getElementById("p2-product-empty-10-jp");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-jp-item-10 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-jp-target-input10").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-10-jp .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateJpTargetInput10();
});

/* 刺繍結果表示 */
$(
    'input[name="attributes[【加工2】1商品目：個人名]"], input[name="attributes[【加工2】1商品目：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】1商品目：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】1商品目：個人名(小ネーム)]"]').val();
    $(".splide-processing-02 .jp .result__wrap.num01 .main").text(mainName);
    $(".splide-processing-02 .jp .result__wrap.num01 .sub").text(subName);
    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-01-jp").css("display", "table-cell");
    $(".p2-step05-personal-01-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-01-jp .main").text(mainName);
    $(".p2-step05-personal-01-jp .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】2商品目：個人名]"], input[name="attributes[【加工2】2商品目：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】2商品目：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】2商品目：個人名(小ネーム)]"]').val();
    $(".splide-processing-02 .jp .result__wrap.num02 .main").text(mainName);
    $(".splide-processing-02 .jp .result__wrap.num02 .sub").text(subName);
    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-02-jp").css("display", "table-cell");
    $(".p2-step05-personal-02-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-02-jp .main").text(mainName);
    $(".p2-step05-personal-02-jp .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】3商品目：個人名]"], input[name="attributes[【加工2】3商品目：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】3商品目：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】3商品目：個人名(小ネーム)]"]').val();
    $(".splide-processing-02 .jp .result__wrap.num03 .main").text(mainName);
    $(".splide-processing-02 .jp .result__wrap.num03 .sub").text(subName);
    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-03-jp").css("display", "table-cell");
    $(".p2-step05-personal-03-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-03-jp .main").text(mainName);
    $(".p2-step05-personal-03-jp .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】4商品目：個人名]"], input[name="attributes[【加工2】4商品目：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】4商品目：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】4商品目：個人名(小ネーム)]"]').val();
    $(".splide-processing-02 .jp .result__wrap.num04 .main").text(mainName);
    $(".splide-processing-02 .jp .result__wrap.num04 .sub").text(subName);
    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-04-jp").css("display", "table-cell");
    $(".p2-step05-personal-04-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-04-jp .main").text(mainName);
    $(".p2-step05-personal-04-jp .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】5商品目：個人名]"], input[name="attributes[【加工2】5商品目：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】5商品目：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】5商品目：個人名(小ネーム)]"]').val();
    $(".splide-processing-02 .jp .result__wrap.num05 .main").text(mainName);
    $(".splide-processing-02 .jp .result__wrap.num05 .sub").text(subName);
    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-05-jp").css("display", "table-cell");
    $(".p2-step05-personal-05-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-05-jp .main").text(mainName);
    $(".p2-step05-personal-05-jp .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】6商品目：個人名]"], input[name="attributes[【加工2】6商品目：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】6商品目：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】6商品目：個人名(小ネーム)]"]').val();
    $(".splide-processing-02 .jp .result__wrap.num06 .main").text(mainName);
    $(".splide-processing-02 .jp .result__wrap.num06 .sub").text(subName);
    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-06-jp").css("display", "table-cell");
    $(".p2-step05-personal-06-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-06-jp .main").text(mainName);
    $(".p2-step05-personal-06-jp .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】7商品目：個人名]"], input[name="attributes[【加工2】7商品目：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】7商品目：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】7商品目：個人名(小ネーム)]"]').val();
    $(".splide-processing-02 .jp .result__wrap.num07 .main").text(mainName);
    $(".splide-processing-02 .jp .result__wrap.num07 .sub").text(subName);
    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-07-jp").css("display", "table-cell");
    $(".p2-step05-personal-07-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-07-jp .main").text(mainName);
    $(".p2-step05-personal-07-jp .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】8商品目：個人名]"], input[name="attributes[【加工2】8商品目：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】8商品目：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】8商品目：個人名(小ネーム)]"]').val();
    $(".splide-processing-02 .jp .result__wrap.num08 .main").text(mainName);
    $(".splide-processing-02 .jp .result__wrap.num08 .sub").text(subName);
    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-08-jp").css("display", "table-cell");
    $(".p2-step05-personal-08-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-08-jp .main").text(mainName);
    $(".p2-step05-personal-08-jp .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】9商品目：個人名]"], input[name="attributes[【加工2】9商品目：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】9商品目：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】9商品目：個人名(小ネーム)]"]').val();
    $(".splide-processing-02 .jp .result__wrap.num09 .main").text(mainName);
    $(".splide-processing-02 .jp .result__wrap.num09 .sub").text(subName);
    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-09-jp").css("display", "table-cell");
    $(".p2-step05-personal-09-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-09-jp .main").text(mainName);
    $(".p2-step05-personal-09-jp .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】10商品目：個人名]"], input[name="attributes[【加工2】10商品目：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】10商品目：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】10商品目：個人名(小ネーム)]"]').val();
    $(".splide-processing-02 .jp .result__wrap.num10 .main").text(mainName);
    $(".splide-processing-02 .jp .result__wrap.num10 .sub").text(subName);
    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-10-jp").css("display", "table-cell");
    $(".p2-step05-personal-10-jp").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-10-jp .main").text(mainName);
    $(".p2-step05-personal-10-jp .sub").text(subName);
});

/* 小ネームの表示切り替え */
$('input[name^="p2-subname-btn-check-jp"]').change(function () {
    const num = $(this).attr("name").slice(-2);
    const selector = `.splide-processing-02 .jp .sub-name__wrap.num${num}`;

    if ($(this).val() === "はい") {
        $(selector).show();
    } else {
        $(selector).hide();
    }
});

/* 入力欄の追加（日本語）*/
$(document).ready(function () {
    let currentIndex = 1;

    $(".splide-processing-02 .add-con-btn-jp__wrap").on("click", function () {
        currentIndex++;
        let nextElement = $(
            ".splide-processing-02 .individual__wrap.btn01.jp.num" + currentIndex.toString().padStart(2, "0")
        );

        if (nextElement.length) {
            nextElement.show();
        }

        const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
        nextButton.classList.add("disabled");
    });
});

/* 個人名側かつ英字フォントの場合 */
/* 個人名（英字フォント）のバリデーションチェック */
// 日本語入力&16文字以上入力時のアラート

/* -------------------- */
/* ------ 1商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-01-en").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-01-en");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-01-en");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-01-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-en-target-input01");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 15;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-01-en").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-01-en");
    const targetInput = document.getElementById("p2-en-target-input01");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 商品情報のバリデーションチェック */
function p2_validateEnTargetInput01() {
    const inputField = document.getElementById("p2-en-target-input01");
    const textErrorMessage = document.getElementById("p2-product-empty-01-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-en-item-01 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-en-target-input01").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-01-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateEnTargetInput01();
});

/* -------------------- */
/* ------ 2商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-02-en").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-02-en");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-02-en");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-02-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-en-target-input02");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 15;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-02-en").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-02-en");
    const targetInput = document.getElementById("p2-en-target-input02");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 商品情報のバリデーションチェック */
function p2_validateEnTargetInput02() {
    const inputField = document.getElementById("p2-en-target-input02");
    const textErrorMessage = document.getElementById("p2-product-empty-02-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-en-item-02 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-en-target-input02").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-02-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateEnTargetInput02();
});

/* -------------------- */
/* ------ 3商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-03-en").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-03-en");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-03-en");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-03-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-en-target-input03");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 15;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-03-en").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-03-en");
    const targetInput = document.getElementById("p2-en-target-input03");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 商品情報のバリデーションチェック */
function p2_validateEnTargetInput03() {
    const inputField = document.getElementById("p2-en-target-input03");
    const textErrorMessage = document.getElementById("p2-product-empty-03-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-en-item-03 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-en-target-input03").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-03-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateEnTargetInput03();
});

/* -------------------- */
/* ------ 4商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-04-en").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-04-en");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-04-en");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-04-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-en-target-input04");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 15;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-04-en").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-04-en");
    const targetInput = document.getElementById("p2-en-target-input04");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 商品情報のバリデーションチェック */
function p2_validateEnTargetInput04() {
    const inputField = document.getElementById("p2-en-target-input04");
    const textErrorMessage = document.getElementById("p2-product-empty-04-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-en-item-04 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-en-target-input04").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-04-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateEnTargetInput04();
});

/* -------------------- */
/* ------ 5商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-05-en").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-05-en");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-05-en");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-05-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-en-target-input05");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 15;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-05-en").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-05-en");
    const targetInput = document.getElementById("p2-en-target-input05");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 商品情報のバリデーションチェック */
function p2_validateEnTargetInput05() {
    const inputField = document.getElementById("p2-en-target-input05");
    const textErrorMessage = document.getElementById("p2-product-empty-05-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-en-item-05 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-en-target-input05").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-05-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateEnTargetInput05();
});

/* -------------------- */
/* ------ 6商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-06-en").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-06-en");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-06-en");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-06-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-en-target-input06");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 15;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-06-en").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-06-en");
    const targetInput = document.getElementById("p2-en-target-input06");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 商品情報のバリデーションチェック */
function p2_validateEnTargetInput06() {
    const inputField = document.getElementById("p2-en-target-input06");
    const textErrorMessage = document.getElementById("p2-product-empty-06-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-en-item-06 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-en-target-input06").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-06-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateEnTargetInput06();
});

/* -------------------- */
/* ------ 7商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-07-en").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-07-en");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-07-en");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-07-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-en-target-input07");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 15;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-07-en").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-07-en");
    const targetInput = document.getElementById("p2-en-target-input07");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 商品情報のバリデーションチェック */
function p2_validateEnTargetInput07() {
    const inputField = document.getElementById("p2-en-target-input07");
    const textErrorMessage = document.getElementById("p2-product-empty-07-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-en-item-07 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-en-target-input07").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-07-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateEnTargetInput07();
});

/* -------------------- */
/* ------ 8商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-08-en").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-08-en");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-08-en");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-08-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-en-target-input08");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 15;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-08-en").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-08-en");
    const targetInput = document.getElementById("p2-en-target-input08");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 商品情報のバリデーションチェック */
function p2_validateEnTargetInput08() {
    const inputField = document.getElementById("p2-en-target-input08");
    const textErrorMessage = document.getElementById("p2-product-empty-08-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-en-item-08 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-en-target-input08").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-08-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateEnTargetInput08();
});

/* -------------------- */
/* ------ 9商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-09-en").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-09-en");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-09-en");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-09-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-en-target-input09");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 15;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-09-en").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-09-en");
    const targetInput = document.getElementById("p2-en-target-input09");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 商品情報のバリデーションチェック */
function p2_validateEnTargetInput09() {
    const inputField = document.getElementById("p2-en-target-input09");
    const textErrorMessage = document.getElementById("p2-product-empty-09-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-en-item-09 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-en-target-input09").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-09-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateEnTargetInput09();
});

/* -------------------- */
/* ------ 10商品目 ------ */
/* -------------------- */
document.getElementById("p2-step05-personal-check-10-en").addEventListener("input", function (e) {
    const inputField = this;
    const alphabetErrorMessage = document.getElementById("p2-step05-personal-error-language-10-en");
    const lengthErrorMessage = document.getElementById("p2-step05-personal-error-length-10-en");
    const textErrorMessage = document.getElementById("p2-step05-personal-error-empty-10-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const targetInput = document.getElementById("p2-en-target-input10");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const exceedsLength = inputField.value.length > 15;
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        alphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        alphabetErrorMessage.style.display = "none";
    }

    if (exceedsLength) {
        inputField.classList.add("error_02");
        lengthErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_02");
        lengthErrorMessage.style.display = "none";
    }

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !exceedsLength && !isEmpty && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 小ネームのバリデーションチェック */
document.getElementById("p2-subname-check-10-en").addEventListener("input", function (e) {
    const inputField = this;
    const nonAlphabetErrorMessage = document.getElementById("p2-subname-language-10-en");
    const targetInput = document.getElementById("p2-en-target-input10");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const containsInvalidCharacters = /[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>\-]/.test(inputField.value);
    const isTargetInputEmpty = targetInput.value.length === 0;

    if (containsInvalidCharacters) {
        inputField.classList.add("error_01");
        nonAlphabetErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_01");
        nonAlphabetErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!containsInvalidCharacters && !isTargetInputEmpty) {
        nextButton.classList.remove("disabled");
    }
});

/* 英字 商品情報のバリデーションチェック */
function p2_validateEnTargetInput10() {
    const inputField = document.getElementById("p2-en-target-input10");
    const textErrorMessage = document.getElementById("p2-product-empty-10-en");
    const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
    const isEmpty = inputField.value.length === 0;

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }
}

$("#p2-en-item-10 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p2-en-target-input10").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p2-step05-personal-10-en .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p2_validateEnTargetInput10();
});

/* 刺繍結果表示 */
$(
    'input[name="attributes[【加工2】1商品目(英)：個人名]"], input[name="attributes[【加工2】1商品目(英)：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】1商品目(英)：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】1商品目(英)：個人名(小ネーム)]"]').val();
    if (subName.length === 1) {
        subName += ".";
    }
    $(".splide-processing-02 .en .result__wrap.num01 .main").text(mainName);
    $(".splide-processing-02 .en .result__wrap.num01 .sub").text(subName);

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-01-en").css("display", "table-cell");
    $(".p2-step05-personal-01-en").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-01-en .main").text(mainName);
    $(".p2-step05-personal-01-en .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】2商品目(英)：個人名]"], input[name="attributes[【加工2】2商品目(英)：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】2商品目(英)：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】2商品目(英)：個人名(小ネーム)]"]').val();
    if (subName.length === 1) {
        subName += ".";
    }
    $(".splide-processing-02 .en .result__wrap.num02 .main").text(mainName);
    $(".splide-processing-02 .en .result__wrap.num02 .sub").text(subName);

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-02-en").css("display", "table-cell");
    $(".p2-step05-personal-02-en").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-02-en .main").text(mainName);
    $(".p2-step05-personal-02-en .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】3商品目(英)：個人名]"], input[name="attributes[【加工2】3商品目(英)：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】3商品目(英)：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】3商品目(英)：個人名(小ネーム)]"]').val();
    if (subName.length === 1) {
        subName += ".";
    }
    $(".splide-processing-02 .en .result__wrap.num03 .main").text(mainName);
    $(".splide-processing-02 .en .result__wrap.num03 .sub").text(subName);

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-03-en").css("display", "table-cell");
    $(".p2-step05-personal-03-en").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-03-en .main").text(mainName);
    $(".p2-step05-personal-03-en .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】4商品目(英)：個人名]"], input[name="attributes[【加工2】4商品目(英)：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】4商品目(英)：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】4商品目(英)：個人名(小ネーム)]"]').val();
    if (subName.length === 1) {
        subName += ".";
    }
    $(".splide-processing-02 .en .result__wrap.num04 .main").text(mainName);
    $(".splide-processing-02 .en .result__wrap.num04 .sub").text(subName);

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-04-en").css("display", "table-cell");
    $(".p2-step05-personal-04-en").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-04-en .main").text(mainName);
    $(".p2-step05-personal-04-en .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】5商品目(英)：個人名]"], input[name="attributes[【加工2】5商品目(英)：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】5商品目(英)：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】5商品目(英)：個人名(小ネーム)]"]').val();
    if (subName.length === 1) {
        subName += ".";
    }
    $(".splide-processing-02 .en .result__wrap.num05 .main").text(mainName);
    $(".splide-processing-02 .en .result__wrap.num05 .sub").text(subName);

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-05-en").css("display", "table-cell");
    $(".p2-step05-personal-05-en").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-05-en .main").text(mainName);
    $(".p2-step05-personal-05-en .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】6商品目(英)：個人名]"], input[name="attributes[【加工2】6商品目(英)：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】6商品目(英)：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】6商品目(英)：個人名(小ネーム)]"]').val();
    if (subName.length === 1) {
        subName += ".";
    }
    $(".splide-processing-02 .en .result__wrap.num06 .main").text(mainName);
    $(".splide-processing-02 .en .result__wrap.num06 .sub").text(subName);

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-06-en").css("display", "table-cell");
    $(".p2-step05-personal-06-en").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-06-en .main").text(mainName);
    $(".p2-step05-personal-06-en .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】7商品目(英)：個人名]"], input[name="attributes[【加工2】7商品目(英)：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】7商品目(英)：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】7商品目(英)：個人名(小ネーム)]"]').val();
    if (subName.length === 1) {
        subName += ".";
    }
    $(".splide-processing-02 .en .result__wrap.num07 .main").text(mainName);
    $(".splide-processing-02 .en .result__wrap.num07 .sub").text(subName);

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-07-en").css("display", "table-cell");
    $(".p2-step05-personal-07-en").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-07-en .main").text(mainName);
    $(".p2-step05-personal-07-en .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】8商品目(英)：個人名]"], input[name="attributes[【加工2】8商品目(英)：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】8商品目(英)：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】8商品目(英)：個人名(小ネーム)]"]').val();
    if (subName.length === 1) {
        subName += ".";
    }
    $(".splide-processing-02 .en .result__wrap.num08 .main").text(mainName);
    $(".splide-processing-02 .en .result__wrap.num08 .sub").text(subName);

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-08-en").css("display", "table-cell");
    $(".p2-step05-personal-08-en").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-08-en .main").text(mainName);
    $(".p2-step05-personal-08-en .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】9商品目(英)：個人名]"], input[name="attributes[【加工2】9商品目(英)：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】9商品目(英)：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】9商品目(英)：個人名(小ネーム)]"]').val();
    if (subName.length === 1) {
        subName += ".";
    }
    $(".splide-processing-02 .en .result__wrap.num09 .main").text(mainName);
    $(".splide-processing-02 .en .result__wrap.num09 .sub").text(subName);

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-09-en").css("display", "table-cell");
    $(".p2-step05-personal-09-en").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-09-en .main").text(mainName);
    $(".p2-step05-personal-09-en .sub").text(subName);
});

$(
    'input[name="attributes[【加工2】10商品目(英)：個人名]"], input[name="attributes[【加工2】10商品目(英)：個人名(小ネーム)]"]'
).on("input", function () {
    var mainName = $('input[name="attributes[【加工2】10商品目(英)：個人名]"]').val();
    var subName = $('input[name="attributes[【加工2】10商品目(英)：個人名(小ネーム)]"]').val();
    if (subName.length === 1) {
        subName += ".";
    }
    $(".splide-processing-02 .en .result__wrap.num10 .main").text(mainName);
    $(".splide-processing-02 .en .result__wrap.num10 .sub").text(subName);

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p2-step05-personal-10-en").css("display", "table-cell");
    $(".p2-step05-personal-10-en").prev("th").css("display", "table-cell");
    $(".p2-step05-personal-10-en .main").text(mainName);
    $(".p2-step05-personal-10-en .sub").text(subName);
});

/* 小ネームの表示切り替え */
$('input[name^="p2-subname-btn-check-en"]').change(function () {
    const num = $(this).attr("name").slice(-2);
    const selector = `.splide-processing-02 .en .sub-name__wrap.num${num}`;

    if ($(this).val() === "はい") {
        $(selector).show();
    } else {
        $(selector).hide();
    }
});

/* 入力欄の追加（英語）*/
$(document).ready(function () {
    let currentIndex = 1;

    $(".splide-processing-02 .add-con-btn-en__wrap").on("click", function () {
        currentIndex++;
        let nextElement = $(
            ".splide-processing-02 .individual__wrap.btn01.en.num" + currentIndex.toString().padStart(2, "0")
        );

        if (nextElement.length) {
            nextElement.show();
        }

        const nextButton = document.querySelector(".splide-processing-btn-02 span.next");
        nextButton.classList.add("disabled");
    });
});

/* 6スライド目 入力チェック */
$(document).ready(function () {
    $('input[name="attributes[【加工2】加工位置の選択]"]').change(function () {
        if ($('input[name="attributes[【加工2】加工位置の選択]"]:checked').length > 0) {
            $(".next.check06").removeClass("disabled");
        } else {
            $(".next.check06").addClass("disabled");
        }
    });
});

/* 7スライド目 入力チェック */
$(document).ready(function () {
    $('input[name="attributes[【加工2】糸色・デザイン色の指定]"]').change(function () {
        if ($('input[name="attributes[【加工2】糸色・デザイン色の指定]"]:checked').length > 0) {
            $(".next.check07").removeClass("disabled");
        } else {
            $(".next.check07").addClass("disabled");
        }
    });
});

/* 8スライド目 入力チェック */
$(document).ready(function () {
    $('input[name="attributes[【加工2】サイズの指定]"]').change(function () {
        if ($('input[name="attributes[【加工2】サイズの指定]"]:checked').length > 0) {
            $(".next.check08").removeClass("disabled");
            $("#input-check-02").text("入力済み").removeClass("red").addClass("black");
        } else {
            $(".next.check08").addClass("disabled");
            $("#input-check-02").text("未入力").removeClass("black").addClass("red");
        }
    });
});

/* 9スライド目 入力結果の確認 */
/* 社名 入力確認テーブル */
$(document).ready(function () {
    // STEP1 加工内容の入力
    $('input[name="attributes[【加工2】加工内容(大枠)]"]').change(function () {
        var checkedValue = $('input[name="attributes[【加工2】加工内容(大枠)]"]:checked').val();

        $(".p2-step01").text(checkedValue);
    });

    // STEP2 加工内容の種類を入力
    $('input[name="attributes[【加工2】加工内容(詳細)]"]').change(function () {
        var checkedValue = $('input[name="attributes[【加工2】加工内容(詳細)]"]:checked').val();

        $(".p2-step02").text(checkedValue);
    });

    // STEP4 デザイン（フォント）の指定
    $('input[name="attributes[【加工2】デザイン(フォント)の指定]"]').change(function () {
        var checkedValue = $('input[name="attributes[【加工2】デザイン(フォント)の指定]"]:checked').val();

        $(".p2-step04").text(checkedValue);
    });

    // STEP5 刺繍する文字を入力（日本語）
    $('input[name="attributes[【加工2】入力する社名(日本語)]"]').on("input", function () {
        var inputValue = $(this).val();

        $(".p2-step05-jp").text(inputValue);
    });

    // STEP5 刺繍する文字を入力（英字）
    $('input[name="attributes[【加工2】入力する社名(英字)]"]').on("input", function () {
        var inputValue = $(this).val();

        $(".p2-step05-en").text(inputValue);
    });

    // STEP6 加工位置の選択
    $('input[name="attributes[【加工2】加工位置の選択]"]').change(function () {
        var checkedValue = $('input[name="attributes[【加工2】加工位置の選択]"]:checked').val();

        $(".p2-step06").text(checkedValue);
    });

    // STEP7 糸色・デザイン色の指定
    $('input[name="attributes[【加工2】糸色・デザイン色の指定]"]').change(function () {
        var checkedValue = $('input[name="attributes[【加工2】糸色・デザイン色の指定]"]:checked').val();

        $(".p2-step07").text(checkedValue);
    });

    // STEP8 サイズの指定
    $('input[name="attributes[【加工2】サイズの指定]"]').change(function () {
        var checkedValue = $('input[name="attributes[【加工2】サイズの指定]"]:checked').val();

        $(".p2-step08").text(checkedValue);
    });
});
